/**
 * La tarjeta donde el dueño aprueba lo que su bot va a saber (GKTIBO-88).
 *
 * **Es el editor.** El dueño nunca toca el `.md` —no es técnico, y el
 * conocimiento lo construye siempre un asistente (decisión del PO,
 * 2026-09-19)—. Lo que sí hace es ver el texto exacto antes de que se guarde y
 * aprobarlo. Esa persona entre el modelo y el archivo es lo único que impide
 * que una invención llegue al bot en silencio.
 *
 * Vive aparte de `Conversacion.tsx` porque es la única parte irreversible de
 * la pantalla y conviene poder leerla de un vistazo, sin el manejo del hilo
 * alrededor. Y porque juntas pasaban las 300 líneas (D4).
 */

import { Button } from '../../components/ui/Button';
import { entrevista } from './textos-entrevista';

export interface Propuesta {
  tema: string;
  texto: string;
  seDescartoLoInventado: boolean;
}

interface TarjetaProps {
  propuestas: Propuesta[];
  /** El modelo no se pudo usar: esto es el texto del dueño, sin ordenar. */
  sinAsistente?: boolean;
  resuelto?: 'guardado' | 'corrigiendo';
  guardando: boolean;
  onGuardar: () => void;
  onCorregir: () => void;
}

export function TarjetaDeConfirmacion({
  propuestas,
  sinAsistente,
  resuelto,
  guardando,
  onGuardar,
  onCorregir,
}: TarjetaProps) {
  const t = entrevista.chat;

  return (
    <div className="alta-chat-propuesta" data-testid="alta-chat-propuesta">
      {/* Que el modelo no haya corrido NO se calla: desde la pantalla es
          indistinguible de un asistente que no entiende, y el dueño se pelea
          con el producto en vez de avisarnos. */}
      {sinAsistente && (
        <p className="alta-chat-sin-asistente" data-testid="alta-chat-sin-asistente">
          {t.sinAsistente}
        </p>
      )}

      {propuestas.map((p) => (
        <div key={p.tema} className="alta-chat-apunte">
          {/* El nombre que el dueño reconoce, no nuestro id. */}
          <p className="alta-chat-apunte-tema">{t.nombreDelTema[p.tema] ?? p.tema}</p>
          {/* El texto EXACTO que va a quedar. No un resumen: lo que apruebe es
              lo que su bot va a decirle a un cliente. */}
          <p className="alta-chat-apunte-texto">{p.texto}</p>
          {p.seDescartoLoInventado && <p className="alta-chat-apunte-aviso">{t.sinInventos}</p>}
        </div>
      ))}

      {resuelto === 'guardado' ? (
        <p className="alta-chat-guardado">{t.guardado}</p>
      ) : (
        resuelto !== 'corrigiendo' && (
          <div className="alta-chat-acciones">
            <Button size="sm" disabled={guardando} onClick={onGuardar}>
              {t.guardar}
            </Button>
            {/* NO abre una caja de texto: manda a hablar con Tibo. */}
            <Button size="sm" variant="secondary" onClick={onCorregir}>
              {t.corregir}
            </Button>
          </div>
        )
      )}
    </div>
  );
}
